import { useLocation, useNavigate } from "react-router";
import { useAppState } from "./hooks";
import classNames from "classnames";
import { MenuPage } from "./reducers";
import { routerBasename } from "../settings";
export function isDetailPanelRouteInternal(pathname) {
  /* Check if we're in a detail panel route from within the app. */
  return pathname.startsWith("/loc");
}
export function isDetailPanelRoute(pathname) {
  /* Some routes imply that the detail panel is open. This does not necessarily
  mean that the context panel will be closed when that panel is navigated to, but
  it takes the routing focus off the context panel's status. */
  // Hack: cover all our bases here by not differentiating between paths that start with
  // routerBasename (i.e. full location paths) vs. react-router internal paths.
  return pathname.startsWith(routerBasename + "loc");
}
export function contextPanelIsInitiallyOpen(pathname) {
  return pathname != routerBasename && !isDetailPanelRoute(pathname);
}
export function useContextPanelOpen() {
  return useAppState(function (s) {
    return s.menu.activePage != null;
  });
}
export function currentPageForPathName(pathname) {
  return Object.values(MenuPage).find(function (page) {
    return pathname.startsWith(routerBasename + page);
  });
}
export function useContextClass() {
  var activePage = useAppState(function (s) {
    return s.menu.activePage;
  });
  if (activePage == null) return null;
  return classNames("panel-open", activePage);
}
export function useCurrentPage() {
  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  return pathname.slice(pathname.lastIndexOf("/") + 1, pathname.length);
}
export function useHashNavigate(to) {
  var navigate = useNavigate();
  return function () {
    navigate(to + location.hash);
  };
}